let routes = [
    {
        path: '/constraint-management',
        name: 'constraint-management',
        component: () => import('@/modules/managers/constraintsManagement/ConstraintsManagement.vue')
    }
]
export default routes
